module.exports = __webpack_public_path__ + "static/icons/oops.a8d5365.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/character/oops.svg
// module id = vlLt
// module chunks = 1